import { MessageType, type UIMessage } from '../types/chat-model'
import TextMessageRender from './text-message-render'

interface Props {
  message: UIMessage
  isLatest?: boolean
  context: unknown // 传入可能的上下文变量
}
//单消息渲染模版,根据模式来渲染不同的消息
export const ChatboxTemplateRenderer: React.FC<Props> = ({
  message,
  isLatest,
  //context,
}) => {
  // 1. 未来拓展点：如果是模板类型
  if (message.type === MessageType.JSON_TEMPLATE) {
    // 这里未来可以引入 LiquidJS 引擎进行渲染
    // return <LiquidRenderer template={message.content} data={context} />;
    return <div className='text-blue-500'>TODO: Liquid Render</div>
  } else if (message.type === MessageType.TEXT) {
    // 2. 文本渲染 (支持 Markdown 或纯文本)
    return <TextMessageRender message={message} isLatest={isLatest} />
  }

  return (
    <div className='leading-relaxed whitespace-pre-wrap'>不支持的渲染类型</div>
  )
}
